import { isNil } from "lodash";

import type { MetricRangeInput } from "./validate-metric-ranges";

export type FindMatchingMetricRangeResult<T extends MetricRangeInput> = {
  requiresMetricRangeEmailNotification: boolean;
  metricRange: T | null;
};

export function findMatchingMetricRange<T extends MetricRangeInput>(
  value: number | null,
  ranges: T[],
): FindMatchingMetricRangeResult<T> {
  if (isNil(value)) return { requiresMetricRangeEmailNotification: false, metricRange: null };

  const exactMatchRange = ranges.find(
    (range) => !isNil(range.rangeMin) && range.rangeMin === range.rangeMax && value === range.rangeMin,
  );
  if (exactMatchRange) {
    return {
      requiresMetricRangeEmailNotification: exactMatchRange.notificationEnabled,
      metricRange: exactMatchRange,
    };
  }

  for (const range of ranges) {
    const min = range.rangeMin ?? -Infinity;
    const max = range.rangeMax ?? Infinity;

    const aboveMin = range.rangeMinInclusive ? value >= min : value > min;
    const belowMax = range.rangeMaxInclusive ? value <= max : value < max;

    if (aboveMin && belowMax) {
      return {
        requiresMetricRangeEmailNotification: range.notificationEnabled,
        metricRange: range,
      };
    }
  }

  return {
    requiresMetricRangeEmailNotification: false,
    metricRange: null,
  };
}
